
const digest = 'c203d92f0666ec3e1a7c2f42edb66aa75a9259a41d52345e89ab7836c08eb55a';
const classes = {"wrapper":"_wrapper_1n9j7_1"};
const css = `._wrapper_1n9j7_1 {
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  